import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuOutputComponent } from './context-menu-output/context-menu-output.component';
import { ContextMenuDirective } from './context-menu.directive';

@NgModule({
  declarations: [
    ContextMenuOutputComponent,
    ContextMenuDirective
  ],
  exports: [
    ContextMenuOutputComponent,
    ContextMenuDirective
  ],
  imports: [
    CommonModule
  ],
  providers: [
  ]
})
export class ContextMenuModule { }
